import * as React from 'react';
import { BaseControlProps } from '../../../models/BaseControlProps';
import { Alert, AlertColor, Snackbar, SnackbarCloseReason } from '@mui/material';


interface MessagePromptProps extends BaseControlProps {
    open: boolean;
    handleClose: (event: React.SyntheticEvent | Event, reason: SnackbarCloseReason) => void;
    message: string | undefined;
    severity: AlertColor;
}

export default function MessagePrompt(props: MessagePromptProps) {

    const handleClose = (event: React.SyntheticEvent) => {
        props.handleClose(event, 'timeout');
    };

    return (
        <Snackbar 
            open={props.open} 
            autoHideDuration={6000} 
            onClose={props.handleClose} 
            anchorOrigin={{ vertical: 'top', horizontal: 'right'}}
        >
            <Alert onClose={handleClose} severity={props.severity} sx={{ width: '100%'}}>
                {props.message}
            </Alert>
        </Snackbar>
    );
}